import { Component } from '@angular/core';

@Component({
  selector: 'app-default-body',
  templateUrl: './default-body.component.html',
  styleUrls: ['./default-body.component.scss']
})
export class DefaultBodyComponent {

}
